import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  sum, values,
} from 'lodash/fp';
import { injectIntl } from 'react-intl';
import messages from '../messages';
import QuestionTitle from './QuestionTitle';
import QuestionInfo from './QuestionInfo';
import DescriptiveAnswers from './DescriptiveAnswers';

const S = {
  QuestionInfo: styled(QuestionInfo)`
    margin-bottom: 24px;
  `,
};

const DescriptiveQuestion = ({
  intl, question, stats, onUpdate,
}) => {
  const count = useMemo(() => sum(values(stats)), [stats]);

  return (
    <div>
      <QuestionTitle number={question.number} onUpdate={onUpdate}>
        {question.content
        || intl.formatMessage(messages.descriptiveQuestionNoContent, { number: question.number })}
      </QuestionTitle>
      <S.QuestionInfo>
        {`단답서술형 / ${question.required ? '필수응답' : '선택응답'} / 응답 ${count}개`}
      </S.QuestionInfo>
      <DescriptiveAnswers
        stats={stats}
      />
    </div>
  );
};

DescriptiveQuestion.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  question: PropTypes.shape({
    number: PropTypes.number.isRequired,
    type: PropTypes.oneOf([
      'SINGLE_SELECTION',
      'MULTIPLE_SELECTION',
      'DESCRIPTIVE',
      // XXX: 하위 호환성 유지를 위한 필드. 추후 제거 예정
      'SINGLE_CHOICE',
      'MULTIPLE_CHOICE',
      'SUBJECTIVE',
    ]).isRequired,
    content: PropTypes.string.isRequired,
    position: PropTypes.shape({
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
    }),
    size: PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
    }),
    required: PropTypes.bool.isRequired,
    field: PropTypes.shape({
      width: PropTypes.number,
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
    }),
    options: PropTypes.arrayOf(PropTypes.shape({
      content: PropTypes.string.isReuqired,
      number: PropTypes.number.isRequired,
      position: PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired,
      }),
    })),
  }).isRequired,
  stats: PropTypes.objectOf(PropTypes.number).isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default injectIntl(DescriptiveQuestion);
